<template>
    <v-sheet>
        <div class="title-rounded mb-30px mb-md-60px" data-aos="fade-up">
            <h2 class="tit white--text">{{title}}</h2>
        </div>
        <slot />
    </v-sheet>
</template>

<script>

export default {
    props: {
        title: { type: String, default: "" },
    },
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";
.title-rounded{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 64px;
    width: fit-content;
    margin: 0 auto;
    padding: 0 36px;
    border-radius: 999px;
    background-color: #59B6E5;
    box-shadow: 4px 4px 15px rgba(158, 115, 69, 0.3);
}
@media (min-width:576px){
}
@media (min-width:768px){
    .title-rounded{
        height: 96px;
        padding: 0 60px;
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>